import React, { useMemo } from 'react'
import { View } from 'react-native'
import { useGetSpace } from '@vatom/sdk/react'
import { observer } from 'mobx-react-lite'

import { withBusinessSelector } from '../../../hooks/useBusinessSelector'
import { AppRoutes, AppStackScreenProps } from '../../../navigators'
import FABRoom from '../components/FAB'
import { getRoomVisibility } from '../components/home-components/RoomItem'
import RoomHeaderWrapper from '../components/RoomHeader/RoomHeaderWrapper'
import { RoomProvider } from '../components/RoomProvider'
import { RoomType } from '../types'

type RoomPageProps = AppStackScreenProps<typeof AppRoutes.CommunitiesRoom | typeof AppRoutes.Room>

const RoomView = observer((props: RoomPageProps) => {
  const { roomTab, spaceId, roomId, business } = props.route.params
  const space = useGetSpace(spaceId)
  const matrixRoomId = space.data?.matrixRoomId ?? roomId ?? ''
  const newRoom = useMemo(
    () =>
      space.data
        ? {
            room_id: matrixRoomId,
            avatar_url: space.data.cover,
            name: space.data.displayName,
            join_rule: getRoomVisibility(space.data.additionalAuth),
            num_joined_members: space.data.members,
            space_id: space.data.id,
            business_id: business
          }
        : null,
    [business, matrixRoomId, space.data]
  ) as RoomType

  if (!space.data) {
    // TODO: Add UI Feedback if not room was found
    console.log('Room not found')
    return null
  }

  return (
    <RoomProvider value={newRoom}>
      <View>
        <RoomHeaderWrapper roomTab={roomTab} />
        <FABRoom spaceId={spaceId} />
      </View>
    </RoomProvider>
  )
})

const RoomViewWithBusinessSelector = withBusinessSelector(RoomView)
export default RoomViewWithBusinessSelector
